import { Component, ErrorHandler, OnInit,ViewChild } from '@angular/core';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import swal from 'sweetalert2';
import { WindowRef } from '../../../shared/windowRef.service';



@Component({
  selector: 'app-installment-payment-form',
  templateUrl: './installment-payment-form.component.html',
  styleUrls: ['./installment-payment-form.component.css'],
  providers: [WindowRef]
})
export class InstallmentPaymentFormComponent implements OnInit {
  @ViewChild('Installment') Installment: NgForm;

  title = "Final Payment(अंतिम भुगतान)";
  userRole: any;
  itemsPerPage: number = 10;
  currentPage: number = 1;
  totalItems: number;
  data: any;
  userName: any;
  o: any = [];
  s: any = [];
  n: any = [];
  payment: any;
  formInvalid: boolean = false;
  paidAmount: number = 0; 
  AmtType: any;
  APP_Id: any;
  PCA_InstallmemntNo: any;
  pay_formData: any;
  pay_data: any;
  appdata: any = [];
  P_Ban_Trans_Ref_No: any;
  paymentStatusinstallment: any;
  installment_Payment_Date: any;
  isPaymentInProgress: boolean;
   isPrintMode: boolean = false;
  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler, winRef: WindowRef) { }
  ngOnInit() {
    this.userName = localStorage.getItem('userName');
    this.GetByIdInstallpaymentApplicant(this.userName);
     console.log(this.paymentStatusinstallment);
    console.log("📢 ngOnInit in LoginComponent");
		window.addEventListener("message", this.receivePaymentMessage.bind(this), false);
		console.log("✅ Message listener added.");
	
		const urlParams = new URLSearchParams(window.location.search);
		this.P_Ban_Trans_Ref_No = urlParams.get('txnid') || '';
		this.paymentStatusinstallment = urlParams.get('status') || '';
		this.installment_Payment_Date = urlParams.get('addedon') || '';
    

  }






  
  GetBYInstallPayment(APP_No) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetApplicantInstallPaymentDetails(APP_No);
    this.data.subscribe(
      (response: any) => {
        this.appdata = response;
        this.o = response.PCAModel;
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
      });
  }

  GetByIdInstallpaymentApplicant(userName) {
    document.getElementById('loader-spinner').style.display = "block";
    this.data = this.userService.GetInstallPaymentDetailsforApplicant(userName);
    this.data.subscribe(
      (response: any) => {
        this.s = response;
        console.log(' data1 :' + JSON.stringify(this.s.APP_Id));
        document.getElementById('loader-spinner').style.display = "none";
      }, (error) => {
        document.getElementById('loader-spinner').style.display = "none";
        this.errorHandler.handleError(error);
      });
  }

  GetInstallPayment(APP_Id) {
    // //debugger;
    this.data = this.userService.GetInstallPaymentDetailsforApplicant(APP_Id);
    this.data.subscribe(
      (response: any) => {
        this.payment = response;
      })
    // this.GetBYInstallPayment(APP_Id);

  }


  SaveInstall(Installment: NgForm) {
     


    if (Installment.invalid) {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }

    else {
      // Installment.value.EMP_ID = this.n.EMP_EMPLOYEE_ID;
      // Nom.value.EbenifitModel = this.NomDetails;      
      
      Installment.value.PCA_Amount = this.paidAmount
      Installment.value.App_Id =this.s[0].APP_Id
      Installment.value.APP_No =this.s[0].APP_No
      Installment.value.PCA_InstallmemntNo =this.PCA_InstallmemntNo

      
      if  (this.o.P_PaymentMode === 'Online' )
      {
      Installment.value.P_Applicant_pay_Date  = this.installment_Payment_Date 
      Installment.value.P_Ban_Trans_Ref_No = this.o.P_Ban_Trans_Ref_No 
      }

      this.data = this.userService.PostInstallPayment_self(Installment.value);
      this.data.subscribe(
        (response) => {
           this.removeBeforeUnloadProtection(); 
          Installment.reset();
          Installment.resetForm();
          Installment.form.markAsPristine();
          Installment.form.markAsUntouched();
          swal('Success!','Paid Successfully .', 'success');
          this.GetBYInstallPayment(this.s[0].APP_No);
           this.o.P_Ban_Trans_Ref_No = null;
           this.paymentStatusinstallment= null;
           this.installment_Payment_Date = null;
          document.getElementById('loader-spinner').style.display = "none";
        }, (error) => {
           this.removeBeforeUnloadProtection(); 
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });


    }
  }

changeCheckbox(selectedAB_Id: number, event: any): void {
  const isChecked = event.target.checked;
  

  this.o.forEach(item => {
    if (item.AB_Id === selectedAB_Id) {
      item.select = isChecked;

      if (isChecked) {
        this.paidAmount = item.PCA_Amount;
        this.PCA_InstallmemntNo = item.PCA_InstallmemntNo;
      } else {
        this.paidAmount = null;
        this.PCA_InstallmemntNo = null;
      }
    } else {
      item.select = false;
    }
  });
}

get isAnyItemSelected(): boolean {
  return this.o && this.o.some(item => item.select);
}
resetForm() {
  // Clear the c object that holds the applicant data
  this.o = {
    P_Bank_BranchName: '',
    P_Ban_Trans_Ref_No: '',
    P_Applicant_pay_Date: '',
  
  };

  // Reset the form values if required
  this.Installment.resetForm();
}
  //  paymentinstallment() {
  //        //saheb
  //       debugger;
        
  //        let englishDistrictName =this.appdata.DI_District.split('(')[0].trim();
        
  //        this.pay_formData = this.Installment.value;
     
      
     
  //        console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
  //        const paydata = {
  //        firstname: this.appdata.APP_PA_Name,
  //        email: this.appdata.APP_PA_Email,
  //        phoneno: this.appdata.APP_PA_MobileNo,
  //        amount: this.paidAmount,
  //        productinfo: this.PCA_InstallmemntNo,
  //        address1: this.appdata.APP_VI_Name_PERM,
  //        address2: this.appdata.Post_Office_PERM,
  //        city: englishDistrictName,
  //        zipcode: this.appdata.APP_Pincode_PERM
  //    };
  //        console.log("requist  payment():", JSON.stringify(paydata));
  //        document.getElementById('loader-spinner').style.display = "block";
  //        this.data = this.userService.Postpayment(paydata);
  //        this.data.subscribe(
  //          (response) => {
  //            document.getElementById('loader-spinner').style.display = "none";
  //            // registerForm.reset();
  //             console.log('selected Response :', response);
  //            this.data = response;
  //            this.pay_data = this.data.data;
  //            console.log('pay data :' + this.pay_data);
           
  //            const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;
     
            
  //            window.open(easebuzzUrl, "_blank");  
             
     
  //          },
  //          (error) => {
  //            document.getElementById('loader-spinner').style.display = "none";
  //            if (error.status == 401) {
  //              this.errorHandler.handleError(error);
  //            }
  //            else if (error.status == 400) {
  //              swal('Warning!', error.error.Message, 'warning');
  //            }
  //          }
  //        );
  //      }




   paymentinstallment() {
 

  if (!this.Installment || !this.Installment.valid) {
    swal('Warning!', 'Please fill all required installment details before proceeding to payment.', 'warning');
    return;
  }

  // Reset old values


  let englishDistrictName = this.appdata.DI_District.split('(')[0].trim();
  this.pay_formData = this.Installment.value;

  const paydata = {
    firstname: this.appdata.APP_PA_Name,
    email: this.appdata.APP_PA_Email,
    phoneno: this.appdata.APP_PA_MobileNo,
    amount: this.paidAmount,
    // productinfo: this.PCA_InstallmemntNo,
    productinfo: 'Final Payment',
    address1: this.appdata.APP_VI_Name_PERM,
    address2: this.appdata.Post_Office_PERM,
    city: englishDistrictName,
    zipcode: this.appdata.APP_Pincode_PERM
  };

  console.log("Form data inside payment():", JSON.stringify(this.pay_formData));
  console.log("Request payment():", JSON.stringify(paydata));

  document.getElementById('loader-spinner').style.display = "block";
  // this.isPaymentInProgress = true;

  this.data = this.userService.Postpayment(paydata);
  this.data.subscribe(
    (response) => {
      document.getElementById('loader-spinner').style.display = "none";
      this.data = response;
      this.pay_data = this.data.data;
      console.log('pay data :' + this.pay_data);

      const easebuzzUrl = `https://testpay.easebuzz.in/pay/${this.pay_data}`;

      // const easebuzzUrl = `https://pay.easebuzz.in/pay/${this.pay_data}`;
      
      window.open(easebuzzUrl, "_blank");  // New tab
    },
    (error) => {
      document.getElementById('loader-spinner').style.display = "none";
      // this.isPaymentInProgress = false;

      if (error.status == 401) {
        this.errorHandler.handleError(error);
      } else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
      }
    }
  );
}









 trustedOrigins = [
    // 'http://localhost:4200',        // your Angular app origin
     'https://portalbshb.esdinfra.com',

    // 'http://localhost:14080',    // your payment API origin
    'https://BSHBAPI.esdinfra.com',

    'https://testpay.easebuzz.in'   // Payment provider domain
  ];

// receivePaymentMessage(event: MessageEvent) {

//     console.log("📬 Received message:", event);


  


//     const data = event.data;
//     if (data && data.txnid && data.status) {
//       this.o.P_Ban_Trans_Ref_No = data.txnid;
//       this.paymentStatusinstallment= data.status;
//       this.installment_Payment_Date = data.addedon;
     
     
//       console.log("saheb transaction Id :", this.P_Ban_Trans_Ref_No);
//       console.log("saheb payment Status :", this.paymentStatusinstallment);
//        console.log("saheb Online Payment Date :", this.installment_Payment_Date);

      
//     }
//     else {
//       console.warn("⚠️ Received message does not contain expected fields:", data);
//     }
//   }

receivePaymentMessage(event: MessageEvent) {
  console.log("📬 Received message:", event);

  const data = event.data;

  if (data && data.txnid && data.status) {
    this.o.P_Ban_Trans_Ref_No = data.txnid;
    this.paymentStatusinstallment = data.status;
    this.installment_Payment_Date = data.addedon;

    console.log("Transaction ID:", this.o.P_Ban_Trans_Ref_No);
    console.log("Payment Status:", this.paymentStatusinstallment);
    console.log("Payment Date:", this.installment_Payment_Date);

    // ✅ Only proceed if payment is successful
    if (data.status.toLowerCase() === 'success') {
      swal('Success!',' Payment successful. Saving details shortly, please wait...', 'success');
      //document.getElementById('loader-spinner').style.display = 'block';
        this.addBeforeUnloadProtection();
    
      // ⏳ Show transaction details to user for 20 seconds
      // console.log("Waiting 20 seconds before auto-saving...");

      setTimeout(() => {
        // ⏳ Small additional delay for Angular's ngModel to bind (optional)
      3
      }, 10000); // 🕒 10 seconds wait before calling SaveInstall
    }
    else{
      swal("Payment Unsuccessful", "Your transaction could not be processed. Please try again.", "warning");
    }
  } else {
    console.warn("⚠️ Incomplete or invalid message data:", data);
  }
}
















isCheckboxDisabled(index: number): boolean {
  // Loop from 0 to the previous index
  for (let i = 0; i < index; i++) {
    if (this.o[i].paymentStatus === 0) {
      return true; // Disable current if any previous is not paid
    }
  }
  return false;
}


onPaymentModeChange(mode: string): void {
  
  if (mode === 'Online') {
    this.o.P_Ban_Trans_Ref_No = null;
    this.o.P_Applicant_pay_Date = null;
    this.o.P_Bank_BranchName = null; // Clear Bank Challan Number
    this.o.P_PaymentMode = 'Online'
    this.paidAmount = this.paidAmount
    this.PCA_InstallmemntNo = this.PCA_InstallmemntNo
  }
}

beforeUnloadHandler = (event: BeforeUnloadEvent) => {
  event.preventDefault();
  event.returnValue = ''; // Standard way to show browser alert on close.
};

addBeforeUnloadProtection() {
  window.addEventListener('beforeunload', this.beforeUnloadHandler);
}

removeBeforeUnloadProtection() {
  window.removeEventListener('beforeunload', this.beforeUnloadHandler);
}

printPage(): void {
  this.isPrintMode = true;

  setTimeout(() => {
    const printContents = document.getElementById('print-section').innerHTML;
    const stylesHtml = this.getTagsHtml('style');
    const linksHtml = this.getTagsHtml('link');
    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');

    const customPrintStyle = `
      <style>
        @media print {
          @page { size: landscape; margin: 1cm; }

          body { zoom: 0.81; }

          table { width: 100% !important; table-layout: fixed; word-wrap: break-word; }

          th, td { font-size: 12px; padding: 4px; word-break: break-word; text-align: center; }

          input, select, button { display: none !important; }

          .no-print { display: none !important; }
        }
      </style>
    `;

    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Installment Details</title>
          ${linksHtml}
          ${stylesHtml}
          ${customPrintStyle}
        </head>
        <body onload="window.print(); window.close()">
          ${printContents}
        </body>
      </html>
    `);
    popupWin.document.close();

    this.isPrintMode = false;
  }, 0);
}




  private getTagsHtml(tagName: keyof HTMLElementTagNameMap): string {
    const htmlStr: string[] = [];
    const elements = document.getElementsByTagName(tagName);
    for (let idx = 0; idx < elements.length; idx++) {
      htmlStr.push(elements[idx].outerHTML);
    }

    return htmlStr.join('\r\n');
  }


}



// WEBPACK FOOTER //
// ./src/app/applicant/installment-payment/installment-payment-form/installment-payment-form.component.ts